module.exports = __webpack_public_path__ + "img/carta-astral.d4eae08e.png";